// jQuery
jQuery(function($){
});